import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

export default function Services() {
  const { t } = useI18n();
  const blocks = t("services.blocks");

  return (
    <div className="max-w-[1320px] mx-auto px-6 lg:px-10 pt-16 pb-24" data-testid="page-services">
      <div className="overline mb-3">Régie · Communication</div>
      <h1 className="serif text-5xl md:text-7xl leading-[1.02]">{t("services.title")}</h1>
      <p className="mt-4 max-w-2xl text-lg text-[rgba(255,255,255,0.75)]">{t("services.sub")}</p>

      <div className="gai-hairline my-12" />

      <div className="grid md:grid-cols-2 gap-[1px] bg-[var(--gai-grey-200)]">
        {blocks.map((b, i) => (
          <div key={i} className="gai-card gai-sharp p-10" data-testid={`service-block-${i}`}>
            <div className="text-[4rem] serif leading-none gai-gradient-gold">{String(i + 1).padStart(2, "0")}</div>
            <h3 className="mt-6 serif text-3xl">{b.t}</h3>
            <p className="mt-4 text-[rgba(255,255,255,0.75)] leading-relaxed">{b.d}</p>
          </div>
        ))}
      </div>

      <div className="mt-16 p-10 md:p-14 border border-[var(--gai-grey-300)]" data-testid="services-pricing-block">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <p className="serif text-2xl md:text-3xl leading-snug text-[var(--gai-white)]">
            {t("services.pricing")}
          </p>
          <div className="md:text-right">
            <Link to="/devis" className="gai-btn-gold" data-testid="services-cta-quote">{t("services.cta")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
